import { render, staticRenderFns } from "./playMp4.vue?vue&type=template&id=1eae630a&scoped=true&"
import script from "./playMp4.vue?vue&type=script&lang=js&"
export * from "./playMp4.vue?vue&type=script&lang=js&"
import style0 from "./playMp4.vue?vue&type=style&index=0&id=1eae630a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae630a",
  null
  
)

export default component.exports